import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/queryClient';
import { SessionProvider } from './features/auth/context/SessionContext';
import { ToastProvider } from './components/Toast';
import App from './App';
import './index.css';

/**
 * Application Entry Point
 *
 * Renders the React application to the DOM with all necessary providers:
 * - StrictMode: Enable React strict mode for development warnings
 * - QueryClientProvider: Provide TanStack Query client for server state management
 * - SessionProvider: Provide shared session state across all components
 * - ToastProvider: Provide toast notification system for user feedback
 * - BrowserRouter: Enable client-side routing with React Router
 */

// Get root element
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found. Ensure index.html has a <div id="root"></div>');
}

// Create React root and render app
createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <ToastProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ToastProvider>
      </SessionProvider>
    </QueryClientProvider>
  </StrictMode>
);
